import { useState } from 'react';
import { Button } from '../Button';
import { Modal, ModalContent, ModalTrigger } from '../Modal';
import { Icon } from '@iconify/react';
import * as S from './style';

export type DownloadHtmlProps = {
  /** HTML content para download/preview */
  htmlContent: string;
  /** Nome do arquivo para download */
  fileName?: string;
  /** Se true, mostra preview antes do download */
  preview?: boolean;
  /** Se true, imprime ao invés de baixar o arquivo */
  print?: boolean;
  /** Se true, baixa o arquivo diretamente sem preview */
  download?: boolean;
  /** Texto do botão */
  buttonText?: string;
  /** Ícone do botão */
  icon?: string;
  /** Callback executado após o download */
  onDownload?: () => void;
}

export function DownloadHtml(props: DownloadHtmlProps) {
  const {
    htmlContent,
    fileName = 'documento.html',
    preview = false,
    print = false,
    download = false,
    buttonText = download ? 'Download' : print ? 'Imprimir' : 'Download HTML',
    icon = download ? 'ph:download' : print ? 'ph:printer' : 'ph:download',
    onDownload
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  function handleDownload() {
    const blob = new Blob([htmlContent], { type: 'text/html;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);

    onDownload?.();
    setIsModalOpen(false);
  }

  function handleClick() {
    if (preview) {
      setIsModalOpen(true);
    } else if (print) {
      handlePrint();
    } else if (download) {
      handleDownload();
    } else {
      handleDownload();
    }
  }

  function handlePrint() {
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(htmlContent);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
    }
  }

  if (preview) {
    return (
      <Modal open={isModalOpen} onOpenChange={setIsModalOpen}>
        <ModalTrigger asChild>
          <Button size="md" onClick={handleClick}>
            <Icon icon={icon} />
            {buttonText}
          </Button>
        </ModalTrigger>
        <ModalContent>
          <S.ModalHeader>
            <S.Title>Preview do Documento</S.Title>
            <S.ButtonGroup>
              <Button size="md" iconName='ph:printer' variant="secondary" onClick={handlePrint}>
                Imprimir
              </Button>
              <Button size="md" iconName='ph:download' onClick={handleDownload}>
                Download
              </Button>
            </S.ButtonGroup>
          </S.ModalHeader>
          <S.PreviewContainer>
            <S.PreviewFrame
              srcDoc={htmlContent}
              title="Preview do documento"
            />
          </S.PreviewContainer>
        </ModalContent>
      </Modal>
    );
  }

  return (
    <Button size="sm" iconName={icon} onClick={handleClick}>
      {buttonText}
    </Button>
  );
}

export default DownloadHtml;